// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscaestadoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaEstado() /localidades/buscaEstado/<id>
 *
 * Proxy to locations-service (Go microservice), endpoint
 *   GET /localidades/findByLocationIDAndLocationType/<id>/state
 * which is dispatched to `findStateByID` and returns `*entity.State`.
 *
 * Source of truth: locations-service Go struct
 *   services/locations-service/src/localidades/state/entity/entity.go → `entity.State`
 *
 * The Go struct has no `json:"…"` tags, so the default encoder emits
 * exported field names verbatim. PHP therefore receives PascalCase keys:
 *   - ID         (uint)
 *   - Name       (string)
 *   - UF         (string)  — state code, e.g. "PR", "SC"
 *   - CountryID  (uint)
 *   - Cities     ([]City) — nested cities slice; typically nil/null on this endpoint
 *
 * The keys must match the wire shape exactly so that the frontend's typed
 * Response can rely on them without a permissive `[key: string]: any` fallback.
 *
 * Mirrors the field set in `Localidades_BuscaestadosRow` (the row shape used
 * by the plural sibling endpoint).
 */
import type { Localidades_BuscacidadesRow } from './Localidades_BuscacidadesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_BuscaestadoResponseDados {
ID?: number
Name?: string
UF?: string
CountryID?: number
Cities?: Localidades_BuscacidadesRow[]
}

export type Localidades_BuscaestadoResponse = ApiResponse<Localidades_BuscaestadoResponseDados>;

registerResponseContract('Localidades_BuscaestadoResponse', {
  ID:        { type: 'number',  required: false },
  Name:      { type: 'string',  required: false },
  UF:        { type: 'string',  required: false },
  CountryID: { type: 'number',  required: false },
  Cities: {
    type: 'array',
    required: false,
    items: {
      ID:      { type: 'number',  required: false },
      Name:    { type: 'string',  required: false },
      StateID: { type: 'number',  required: false },
    },
  },
})
